import { render, staticRenderFns } from "./ImsSlider.vue?vue&type=template&id=288607f7"
import script from "./ImsSlider.vue?vue&type=script&lang=js"
export * from "./ImsSlider.vue?vue&type=script&lang=js"
import style0 from "./ImsSlider.vue?vue&type=style&index=0&id=288607f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports